import { FC, useEffect } from "react";
import { useSetRecoilState } from "recoil";

import { Settings } from "@ryde/layout";
import { settingsDrawerOpenStateAtom } from "@ryde/shared";

export const SettingsWrapper: FC = () => {
  const setSettingsBarOpenState = useSetRecoilState(
    settingsDrawerOpenStateAtom,
  );
  useEffect(() => {
    setSettingsBarOpenState(false);
  }, [setSettingsBarOpenState]);
  return <Settings />;
};
